<template>
  <v-overlay color="#fff">
    <v-card
      light
      class="mx-auto"
      max-width="400"
    >
      <v-img
        class="white--text align-end"
        height="200px"
        src="https://www.grouphealth.ca/wp-content/uploads/2018/05/placeholder-image.png"
      />
      <v-card-text class="text--primary">
        <v-progress-linear
          indeterminate
          color="primary"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          href="https://app.thruuu.com/create-account"
          target="_blank"
        >
          Try thruuu for free
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>

<script>
export default {}
</script>
